export default {
  iconImages: [
    {
      back: require('@imgs/footIcon-light/back.png'),
      bgmusic: require('@imgs/footIcon-light/bg-music.png'),
      download: require('@imgs/footIcon-light/download-tip.png'),
      share: require('@imgs/footIcon-light/footer_qrcard.png'),
      zoomIn: require('@imgs/footIcon-light/fangda.png'),
      zoomOut: require('@imgs/footIcon-light/suoxiao.png'),
      fullScreen: require('@imgs/footIcon-light/quanpin.png'),
      listen: require('@imgs/footIcon-light/listen.png'),
      stream: require('@imgs/footIcon-light/pc-streaming.png'),
      officialWeb: require('@imgs/footIcon-light/officialWeb.png'),
      prePage: require('@imgs/footIcon-light/footer_left_one.png'),
      nextPage: require('@imgs/footIcon-light/footer_right_one.png'),
      firstPage: require('@imgs/footIcon-light/footer_left_two.png'),
      lastPage: require('@imgs/footIcon-light/footer_right_two.png'),
      historyResource: require('@imgs/footIcon-light/histroy-light.png'),
      article: require('@imgs/footIcon-light/footer_article.png'),
      catalog: require('@imgs/footIcon-light/footer_list.png'),
      thumbnail: require('@imgs/footIcon-light/thumb-icon.png'),
      mobileContent: require('@imgs/mobile_footer/footer_list.png'),
      mobileArticle: require('@imgs/mobile_footer/footer_article.png'),
      goArticle: require('@imgs/mobile_footer/footer_searchArticle.png'),
      mobileHelp: require('@imgs/mobile_footer/footer_help.png'),
      mobilePrePage: require('@imgs/mobile_footer/footer_left_one.png'),
      mobileNextPage: require('@imgs/mobile_footer/footer_right_one.png'),
      mobileFirstPage: require('@imgs/mobile_footer/footer_left_two.png'),
      mobileLastPage: require('@imgs/mobile_footer/footer_right_two.png'),
      mobileFooterPage: require('@imgs/mobile_footer/footer_page.png'),
      mobilePoster: require('@imgs/mobile_footer/footer_poster.png'),
      mobileStream: require('@imgs/mobile_footer/footer_stream-light.png'),
      mobileSoundOn: require('@imgs/mobile_footer/sound_on.png'),
      mobileSoundOff: require('@imgs/mobile_footer/sound_off.png'),
      mobileThumbnail: require('@imgs/mobile_footer/thumb.png'),
      lock: require('@imgs/mobile_footer/footer_lock.png'),
      mobileMore: require('@imgs/mobile_footer/footer_more.png'),
      mobileOfficial: require('@imgs/mobile_footer/official-light.png'),
      mobileListen: require('@imgs/mobile_footer/listen-light.png'),
      homepage: require('@imgs/mobile_footer/homepage-light.png'),
      libBack: require('@imgs/mobile_footer/libBack-light.png'),
      login: require('@imgs/mobile_footer/login-light.png'),
      wechatIcon: require('@imgs/mobile_footer/wechat-light.png'),
      linkIcon: require('@imgs/mobile_footer/link-light.png'),
      posterIcon: require('@imgs/mobile_footer/poster-light.png'),
      mobileSearch: require('@imgs/mobile_footer/search_mobile.png')
    },
    {
      back: require('@imgs/footIcon-dark/back.png'),
      bgmusic: require('@imgs/footIcon-dark/bg-music.png'),
      download: require('@imgs/footIcon-dark/download-tip.png'),
      share: require('@imgs/footIcon-dark/footer_qrcard.png'),
      zoomIn: require('@imgs/footIcon-dark/fangda.png'),
      zoomOut: require('@imgs/footIcon-dark/suoxiao.png'),
      fullScreen: require('@imgs/footIcon-dark/quanpin.png'),
      listen: require('@imgs/footIcon-dark/listen.png'),
      stream: require('@imgs/footIcon-dark/pc-streaming.png'),
      officialWeb: require('@imgs/footIcon-dark/officialWeb.png'),
      prePage: require('@imgs/footIcon-dark/footer_left_one.png'),
      nextPage: require('@imgs/footIcon-dark/footer_right_one.png'),
      firstPage: require('@imgs/footIcon-dark/footer_left_two.png'),
      lastPage: require('@imgs/footIcon-dark/footer_right_two.png'),
      historyResource: require('@imgs/footIcon-dark/histroy.png'),
      article: require('@imgs/footIcon-dark/footer_article.png'),
      catalog: require('@imgs/footIcon-dark/footer_list.png'),
      thumbnail: require('@imgs/footIcon-dark/thumb-icon.png'),
      mobileContent: require('@imgs/mobile_footer/footer_list-dark.png'),
      mobileArticle: require('@imgs/mobile_footer/footer_article-dark.png'),
      goArticle: require('@imgs/mobile_footer/footer_searchArticle-dark.png'),
      mobileHelp: require('@imgs/mobile_footer/footer_help-dark.png'),
      mobilePrePage: require('@imgs/mobile_footer/footer_left_one-dark.png'),
      mobileNextPage: require('@imgs/mobile_footer/footer_right_one-dark.png'),
      mobileFirstPage: require('@imgs/mobile_footer/footer_left_two-dark.png'),
      mobileLastPage: require('@imgs/mobile_footer/footer_right_two-dark.png'),
      mobileFooterPage: require('@imgs/mobile_footer/footer_page-dark.png'),
      mobilePoster: require('@imgs/mobile_footer/footer_poster-dark.png'),
      mobileStream: require('@imgs/mobile_footer/footer_stream-dark.png'),
      mobileSoundOn: require('@imgs/mobile_footer/sound_on-dark.png'),
      mobileSoundOff: require('@imgs/mobile_footer/sound_off.png'),
      mobileThumbnail: require('@imgs/mobile_footer/thumb-dark.png'),
      lock: require('@imgs/mobile_footer/footer_lock-dark.png'),
      mobileMore: require('@imgs/mobile_footer/footer_more-dark.png'),
      mobileOfficial: require('@imgs/mobile_footer/official-dark.png'),
      mobileListen: require('@imgs/mobile_footer/listen-dark.png'),
      homepage: require('@imgs/mobile_footer/homepage-dark.png'),
      libBack: require('@imgs/mobile_footer/libBack-dark.png'),
      login: require('@imgs/mobile_footer/login-dark.png'),
      wechatIcon: require('@imgs/mobile_footer/wechat-dark.png'),
      linkIcon: require('@imgs/mobile_footer/link-dark.png'),
      posterIcon: require('@imgs/mobile_footer/poster-dark.png'),
      mobileSearch: require('@imgs/mobile_footer/search_mobile-dark.png')
    }
  ]
}
